import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import StorageUsage from './StorageUsage.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/storage-usage'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_storage_usage',
          component: StorageUsage,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
